import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
 function WhyBuy() {
  return (
    <>
      <section className="Lt_whyBuy_section">
        <Container className="rcs_custome_container">
          <Row className="m-0 w-100">
            <Col lg={12} md={12} className="mb-5">
              <div className="Lt_title_text">
                <h2> Why Buy From Belgium </h2>
              </div>
            </Col>

            <Col lg={4} md={4}>
              <div className="am_box">
                <LazyLoadImage alt="Personalised for you" src={`${ImageUrl}theme/london/ring-style/rings_1.png`} />
                <h6 className="tt-title">Personalised for you</h6>
                <p>
                  Experience our friendly service dealing directly with our
                  expert jewellers in a relaxed environment.
                </p>
              </div>
            </Col>
            <Col lg={4} md={4}>
              <div className="am_box">
                <LazyLoadImage alt="Personalised for you" src={`${ImageUrl}theme/london/ring-style/rings_2.png`} />
                <h6 className="tt-title">Personalised for you</h6>
                <p>
                  Experience our friendly service dealing directly with our
                  expert jewellers in a relaxed environment.
                </p>
              </div>
            </Col>
            <Col lg={4} md={4}>
              <div className="am_box">
                <LazyLoadImage alt="Personalised for you" src={`${ImageUrl}theme/london/ring-style/rings_3.png`} />
                <h6 className="tt-title">Personalised for you</h6>
                <p>
                  Experience our friendly service dealing directly with our
                  expert jewellers in a relaxed environment.
                </p>
              </div>
            </Col>

            <Col>
            <div className="text-center">
                    <Link to="#" className="abt-heading">Learn More </Link>
                </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default WhyBuy;
